import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiShoppingCart } from 'react-icons/fi';
import { useCart } from '../context/CartContext';

const Header = () => {
  const { cartCount } = useCart();
  const navigate = useNavigate();

  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <h1 className="text-2xl font-heading font-bold tracking-tighter text-primary-main">
              Precision Peptides AU
            </h1>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className="text-sm font-medium text-text-secondary hover:text-text-primary transition-colors"
              data-testid="nav-home"
            >
              Home
            </Link>
            <Link
              to="/shop"
              className="text-sm font-medium text-text-secondary hover:text-text-primary transition-colors"
              data-testid="nav-shop"
            >
              Shop
            </Link>
            <Link
              to="/quality"
              className="text-sm font-medium text-text-secondary hover:text-text-primary transition-colors"
              data-testid="nav-quality"
            >
              Quality & Testing
            </Link>
            <Link
              to="/about"
              className="text-sm font-medium text-text-secondary hover:text-text-primary transition-colors"
              data-testid="nav-about"
            >
              About
            </Link>
            <Link
              to="/faq"
              className="text-sm font-medium text-text-secondary hover:text-text-primary transition-colors"
              data-testid="nav-faq"
            >
              FAQ
            </Link>
            <Link
              to="/contact"
              className="text-sm font-medium text-text-secondary hover:text-text-primary transition-colors"
              data-testid="nav-contact"
            >
              Contact
            </Link>
          </nav>

          <button
            onClick={() => navigate('/cart')}
            className="relative p-2 hover:bg-slate-50 rounded-md transition-colors"
            data-testid="cart-button"
          >
            <FiShoppingCart className="w-6 h-6 text-primary-main" />
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-accent-main text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center" data-testid="cart-count">
                {cartCount}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
